import React from "react";

import { ThemeColor } from "../../lib/theme/theme";
import { iconClass, iconColorStyles } from "./icon-component-wrapper.css";
import { IconProps } from "./ticon-component-wrapper";

interface IconComponentWrapperProps extends IconProps {
  children: JSX.Element;
}

const rectangleSizes = {
  "16": 18,
  "20": 32, // 20 shouldn't be used but is here for completeness
  "24": 36,
  "32": 48,
  "40": 56,
  "60": 96,
  "80": 96,
} as const;

export const IconComponentWrapper = (
  props: IconComponentWrapperProps
): JSX.Element => {
  const { children, sizeVariant = 24, color, isRectangle, ...svgprops } = props;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  return React.cloneElement(children, {
    ...children.props,
    ...svgprops,
    width: isRectangle
      ? `${rectangleSizes[sizeVariant.toString() as keyof typeof rectangleSizes]}px`
      : `${sizeVariant}px`,
    height: `${sizeVariant}px`,
    className: `${iconClass} ${iconColorStyles({
      color: color as keyof ThemeColor,
    })}`,
  });
};
